import { Card, Drawer, Layout } from 'antd';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import MainHeader from './main-header';
import Sidebar from './sidebar';
import classes from './user-main-layout.module.css';
const { Header, Content, Sider } = Layout;

function UserMainLayout({ children, type }) {
   const router = useRouter();
   const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

   useEffect(() => {
      const closeSidebar = () => setMobileSidebarOpen(false);

      router.events.on('routeChangeStart', closeSidebar);
      return () => router.events.off('routeChangeStart', closeSidebar);
   }, [router.events]);

   return (
      <>
         <Layout style={{ minHeight: '100vh', background: '#F9FAFC' }}>
            <Header className={classes.header}>
               <MainHeader type={type} onMenuClick={() => setMobileSidebarOpen(true)} />
            </Header>

            <Drawer
               className={classes.mobileDrawer}
               placement="left"
               width={280}
               open={mobileSidebarOpen}
               onClose={() => setMobileSidebarOpen(false)}
               styles={{ body: { padding: '0 16px' } }}
            >
               <Sidebar type={type} mobile />
            </Drawer>

            <Layout className={classes.main} style={{ background: '#F9FAFC' }}>
               <Sider theme="light" className={classes.sidebar}>
                  <Sidebar type={type} />
               </Sider>
               <Card className={classes.container} styles={{ body: { padding: 0 } }}>
                  <Content>{children}</Content>
               </Card>
            </Layout>
         </Layout>
      </>
   );
}

export default UserMainLayout;
